import { cn } from '@/lib/utils';

import Card from '@/components/atoms/Card';
import { ImageStrapiProps } from '@/components/atoms/Image/ImageStrapi';
import LinkButton from '@/components/atoms/LinkButton';
import { LinkButtonStrapiProps } from '@/components/atoms/LinkButton/LinkStrapi';
import { transformFromCMSLink } from '@/components/atoms/LinkButton/utils';

import { passPhTracker } from '@/integrations/trackingScripts/utils';

import { LabeledIconCardContent } from './LabeledIconCardContent';

export type LabeledIconCardItem = {
  image: ImageStrapiProps;
  title: string;
  text: string;
  link?: LinkButtonStrapiProps;
};

export type LabeledIconCardProps = {
  item: LabeledIconCardItem;
};

const cardClassName = cn(
  'flex w-full flex-col items-center gap-4 rounded px-3 py-5 min-w-[120px]',
  'md:flex-row md:items-center md:justify-center md:rounded-2xl md:p-5',
  'border-gray-300 bg-gray-100 dark:border-gray-dark-700 dark:bg-gray-dark-900'
);

export function LabeledIconCard({
  item: { image, title, text, link },
}: LabeledIconCardProps) {
  if (!link?.url) {
    return (
      <div data-tracker-component='labeled-icon-card'>
        <Card
          roudnessLevel='s'
          padSize='s'
          classNames={{ root: cardClassName }}
        >
          <LabeledIconCardContent image={image} title={title} text={text} />
        </Card>
      </div>
    );
  }

  const { href, openInNewTab, target } = transformFromCMSLink(link);

  return (
    <LinkButton
      href={href}
      openInNewTab={openInNewTab}
      target={target}
      noStyles
      aria-label={`${title}: ${text}`}
      data-tracker-component='labeled-icon-card'
      {...passPhTracker(link.phTracker)}
    >
      <Card
        roudnessLevel='s'
        padSize='s'
        hasHoverEffect
        classNames={{ root: cardClassName }}
      >
        <LabeledIconCardContent image={image} title={title} text={text} />
      </Card>
    </LinkButton>
  );
}
